import styled from 'styled-components';

export const Info = styled.div`
  .tooltip {
    display: none;
  }

  @media (min-width: 768px) {
    .tooltip {
      display: block;
      visibility: hidden;
      background-color: #fff;
      color: #555;
      border: 1px solid #ccc;
      text-align: center;
      border-radius: 4px;
      padding: 0.4rem 1rem;
      transform: translateX(-20px);
      transition: 0.3s ease-in-out;
      opacity: 0;
      position: absolute;
      z-index: 1;
      text-transform: capitalize !important;
      font-size: 0.9rem;
      top: -57px;
      left: -360px;
      width: 350px;
      box-shadow: 0px 0px 60px 0px rgba(0, 0, 0, 0.1);

      &:after {
        content: '';
        position: absolute;
        bottom: 3%;
        right: -11px;
        margin-top: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: transparent transparent transparent #ccc;
      }
    }

    &:hover .tooltip {
      transform: translateX(0px);
      visibility: visible;
      opacity: 1;
    }
  }
`;
export const FormContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  > svg {
    margin-right: 2rem;
    margin-top: 2.3rem;
  }
`;

export const InputGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  height: 100px;

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
    gap: 0px;
    height: auto;
  }
`;

export const ActionsForm = styled.div`
  width: 34%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2.35rem;
  margin-left: 2rem;

  @media (max-width: 992px) {
    width: 100%;
    justify-content: space-between;
    align-items: center;
    margin-top: unset;
    margin-left: unset;
  }
`;
